<template>
  <b-row class="d-flex px-sm-4 px-md-4 pr-lg-3 pl-lg-1 pt-sm-3">
    <b-col
      cols="12"
      class="d-flex align-items-center justify-content-between"
    >
      <h4 class="c-black">Olá {{ userName }}! Que bom te ver por aqui.</h4>
      <b-button
        class="ml-3"
        pill
        variant="primary"
        title="Atualizar"
        :disabled="loading"
        @click="get()"
      >
        <i class="fas fa-sync"></i>
      </b-button>
    </b-col>
    <b-col class="mt-2">
      <b-button 
        class="mr-3" 
        variant="danger"
        @click="$refs.videoManual.toggleOpen({ 
          url: 'https://www.youtube.com/watch?v=7v7npTpAl_I&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=10', 
          title: 'Tela Inicial' 
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
      <a class="btn btn-success" href="https://api.construp.com.br/assets/Manual - Inicio  (1).pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
  
    </b-col>
    <b-col cols="12" class="mb-4 mt-3">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="fields.startDate"
        :endDate.sync="fields.endDate"
        :limparDados="limpar"
        @click.native="get()"
      />
    </b-col>
    <b-col cols="12">
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="12" sm="6" class="mt-4">
              <Card
                :loading="loading"
                title="Pedidos aprovado"
                icon="fas fa-check-circle"
                backgroundColor="bg-green"
                :number="fields.approvedOrders"
                :linkRota="typeRouteById()"
                :statusPedido="'2-3-4'"
                class="cardPointer"
              />
            </b-col>
            <b-col cols="12" sm="6" class="mt-4">
              <Card
                :loading="loading"
                title="Pedidos cancelado"
                icon="fas fa-times-circle"
                backgroundColor="bg-red"
                :number="fields.canceledOrders"
                :linkRota="typeRouteById()"
                :statusPedido="'6'"
                class="cardPointer text-inline"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="6" class="mt-4">
              <Card
                :loading="loading"
                formatToMoney
                title="Faturamento"
                icon="fas fa-dollar-sign"
                backgroundColor="bg-green"
                :number="fields.invoicing"
                :linkRota="typeRouteById()"
                :statusPedido="'2-3-4'"
                class="cardPointer"
              />
            </b-col>
            <b-col cols="12" sm="6" class="mt-4">
              <Card
                :loading="loading"
                formatToMoney
                title="Valor de pedidos a serem pagos"
                icon="fas fa-hand-holding-usd"
                backgroundColor="bg-yellow"
                :number="fields.toReceive"
                :linkRota="typeRouteById()"
                :statusPedido="'1'"
                class="cardPointer"
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" class="mt-4">
              <!-- <a
                href="https://wa.me/5519992065613"
                target="_blank"
                rel="noopener noreferrer"
              > -->
              <div>
                  <StatisticsCard />
              </div>
              <img
                class="img-fluid w-100 mt-4"
                src="@/assets/img/venda-mais-dashboard-lojista.png"
              />
            <!-- </a> -->
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    
    <VideoManual ref="videoManual"/>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Card from './Card.vue'; 
import StatisticsCard from './StatisticsCard.vue';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: 'DashboardHome',
  components: { Card, StatisticsCard, PeriodsFilters, VideoManual },
  computed: {
    ...mapState(['dadosUsuario']),
    userName() {
      if(this.$route.meta.userType == UserTypes.BALCONISTA) return  this.dadosUsuario.nome_usuario;
      return this.dadosUsuario.informacoes.nome_fantasia;
    },
  },
  data() {
    return {
      loading: false,
      limpar: false,
      fields: {
        approvedOrders: 0,
        canceledOrders: 0,
        invoicing: 0,
        toReceive: 0,
        startDate: '',
        endDate: '', 
        userClerk:'',
      },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    ...mapActions('shopkeeper', ['getInvoicingSummary']),
    get() {
      if (this.loading) return;

      this.loading = true;

      const request = {
        userId: this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id,
        clerkId: this.whatClerkPermission(),  
        ...this.fields,
      };

      this.getInvoicingSummary(request)
        .then((response) => {
          const { approvedOrders, canceledOrders, invoicing, toReceive } =
            response.data.data || {};

          this.fields.approvedOrders = approvedOrders;
          this.fields.canceledOrders = canceledOrders;
          this.fields.invoicing = invoicing;
          this.fields.toReceive = toReceive;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    typeRouteById(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? 'balconista-pedidos-app' : 'lojista-pedidos-app';
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const homePermission = permissionClerk.find(element => element.name == NamePermission.INICIO);
  
        if(this.$route.meta.userType == UserTypes.BALCONISTA && homePermission.type == TypePermission.BALCONISTA){
          return this.dadosUsuario.id;
        }
      }
      return '';
    }
  },
};
</script>

<style scoped>
.cardPointer {
  cursor: pointer;
}

</style>